import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from "@angular/core";
import { SharedService, copyToClipboard } from '../../shared';
import { TitrationEventType, TherapieTabsEnum } from '../titration-rechner.model';
import { PartnerNamesEnum } from "../../medizinisches-cannabisantrag";


@Component({
    selector: 'app-titration-rezept',
    templateUrl: "./titration-rezept.component.html",
    styleUrls: ["./titration-rezept.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationRezeptComponent implements OnInit {
    @Input() partnerName: any = "";
    @Input() ActiveTherapieTab: TherapieTabsEnum = null;
    @Input() arzneimitText: any = "";
    @Input() dosierungText: any = "";

    @Output() onBtnCLick: EventEmitter<any> = new EventEmitter();

    PartnerNamesEnum = PartnerNamesEnum;

    get rezeptText() {
        return this.dosierungText;
    }

    get hasColumnView() {
        return this.jsPanelContentWidth < 960 ? true : false;
    }

    get jsPanelContentWidth() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientWidth;
        }
        else {
            return document.body.clientWidth;
        }
    }

    constructor(private sharedService: SharedService) {

    }

    ngOnInit(): void {

    }

    printRezept() {
        this.onBtnCLick.emit(TitrationEventType.PrintRezept);
        var html = document.getElementById("print-rezept-gelb").outerHTML;
        this.sharedService.printHTMLData(html, {
            headCss: true
        });
    }

    copyRezept() {
        this.onBtnCLick.emit(TitrationEventType.CopyRezept);
        copyToClipboard(this.rezeptText);
    }
}
